import Container from 'saur_ui_library/src/Atoms/Container/Container';
import ModalFlexible from 'saur_ui_library/src/Organisms/ModalFlexible/ModalFlexible';
import React, { FC } from "react";
import { createGlobalStyle } from "styled-components";
import { ProgressSpinner } from 'primereact/progressspinner';
type LoaderProps = {
  IsVisible: any;
};

 const Loader: FC<LoaderProps> = (props) =>{
   const popupContent = () => (
     <Container
       className='loadercontentContainer'
       style={{ width: 550, height: 500, backgroundColor: 'transparent' }}
     >
       <ProgressSpinner className='spinner' />
     </Container>
   );
   
  return(
    <Container className="loaderContainer">
      <Styles/>      
     <ModalFlexible
    className="loader-modal"
    showHeader={false}
    title=""
    toggleModal={() => { console.log("")}}
    visible={props.IsVisible}
    desktopContent={popupContent}  
  /></Container>
  )
}
const Styles = createGlobalStyle`
.p-progress-spinner-circle {
    /* fix for IE browsers */
    stroke: #d62d20;
    stroke-dasharray: 89,200;
}
.sds-reset-style{ 
.loaderContainer{
    z-index:200; 
  .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position .modal-flex-desktop-content{
    background-color: transparent;
  }
  .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position .modal-flex-desktop-content .modal-flex-desktop-header {
    align-items: flex-end !important;
    flex-direction: column;
    padding: 0px;
  }
  .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position .modal-flex-desktop-content .modal-flex-desktop-header .modal-flex-desktop-header-icon svg{
    height:0px;
  }
  div.sds-container.loadercontentContainer{
    align-self: center;
    .spinner{
      align-self: center;
      display: inline-block;
      height: 100%;
    }
  }
}
}
 
`;
export default  Loader